import GeoJSON from 'ol/format/GeoJSON.js';

export default function readfeaturesWithProj(from, to, datas, format) {
    var result;
    if (from == to) {
        result = format.readFeatures(datas);
    } else {
        try {
            if (from != 'EPSG:3857' && to != 'EPSG:3857') {
                var features = format.readFeatures(datas, {
                    featureProjection: 'EPSG:3857',
                    dataProjection: from
                });

                try {

                    var new_datas = format.writeFeatures(features, {
                        featureProjection: 'EPSG:3857',
                        dataProjection: to
                    });
                    result = format.readFeatures(new_datas);

                } catch (e) {

                    var new_datas = (new GeoJSON()).writeFeatures(features, {
                        featureProjection: 'EPSG:3857',
                        dataProjection: to
                    });

                    result = (new GeoJSON()).readFeatures(new_datas);

                }

            } else {
                result = format.readFeatures(datas, {
                    featureProjection: to,
                    dataProjection: from
                });
            }
        }
        catch (e) {
            console.error("tsaanaas irj baigaa featuruuded asuudal baina");
        }
    }
    return result;
};
